var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcZoneDevices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 1H13V3H15V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4H13V6H15V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1H10V3H12V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4H10V6H12V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10H7V11H8V13H7V14H11.5V13H9V11H14C14.2652 11 14.5196 10.8946 14.7071 10.7071C14.8946 10.5196 15 10.2652 15 10V7H14V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3H9V2H3C2.7348 2 2.4804 2.10535 2.2929 2.2929C2.10535 2.4804 2 2.7348 2 3V6H3V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7H2C1.7348 7 1.4804 7.10535 1.2929 7.2929C1.10535 7.4804 1 7.7348 1 8V14C1 14.2652 1.10535 14.5196 1.2929 14.7071C1.4804 14.8946 1.7348 15 2 15H5C5.2652 15 5.5196 14.8946 5.7071 14.7071C5.89465 14.5196 6 14.2652 6 14V8C6 7.7348 5.89465 7.4804 5.7071 7.2929C5.5196 7.10535 5.2652 7 5 7ZM5 14H2V8H5V14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcZoneDevices);
export default __webpack_public_path__ + "static/media/ic-zone-devices.aec8bc4a79aba235bf405fd3ea056096.svg";
export { ForwardRef as ReactComponent };